import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 15.269 12"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.269 1.636A1.636 1.636 0 0 0 13.633 0H6.816A1.636 1.636 0 0 0 5.18 1.636v.545H3a3 3 0 0 0-3 3V9a.818.818 0 0 0 .818.818h.872a2.727 2.727 0 0 0 5.344 0h1.745a2.727 2.727 0 0 0 5.344 0h.6a.545.545 0 0 0 .545-.545ZM1.909 5.453a.273.273 0 0 1-.273-.273A1.365 1.365 0 0 1 3 3.817h1.09a.273.273 0 0 1 .273.273v1.09a.273.273 0 0 1-.273.273Zm2.454 4.908a1.091 1.091 0 1 1 1.09-1.091 1.091 1.091 0 0 1-1.091 1.091Zm7.089 0a1.091 1.091 0 1 1 1.091-1.091 1.091 1.091 0 0 1-1.092 1.091Z" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }